import { breakpoints } from './variables';

export const debounce = (callback: (args: unknown) => void, wait: number) => {
  let timerId: ReturnType<typeof setTimeout>;

  return (...args: [unknown]) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      callback(...args);
    }, wait);
  };
};

const isTablet = () => {
  return window.matchMedia(
    `(min-width: ${breakpoints.tabletLandscape}px) and (max-width: ${breakpoints.desktop - 1}px)`
  ).matches;
};

const isMobile = () => {
  return window.matchMedia(`(max-width: ${breakpoints.tabletLandscape - 1}px)`).matches;
};

const isDesktop = () => {
  return window.matchMedia(`(min-width: ${breakpoints.tabletLandscape - 1}px)`).matches;
};

const isLargeDesktop = () => {
  return window.matchMedia(`(min-width: ${breakpoints.desktop - 1}px)`).matches;
};

const prefersReducedMotion = () => {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

export { isTablet, isMobile, isDesktop, isLargeDesktop, prefersReducedMotion };
